import { createContext } from 'react'

import * as ar from '@/data/ar'
import * as en from '@/data/en'

/** The languages the site speaks: each one's copy and writing direction. */
export const LOCALES = {
  en: { data: en, dir: 'ltr' },
  ar: { data: ar, dir: 'rtl' },
}

const STORAGE_KEY = 'locale'

/** `Layout` provides the real value; this default only serves stray renders. */
export const LocaleContext = createContext({ locale: 'en', toggle() {} })

/** The visitor's saved choice, else their browser's language, else English. */
export function initialLocale() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved in LOCALES) return saved
  } catch {
    // Storage blocked (private mode, sandbox): fall through to the browser.
  }
  return navigator.language?.toLowerCase().startsWith('ar') ? 'ar' : 'en'
}

export function saveLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // Storage blocked: the choice simply won't outlive the tab.
  }
}
